import { type } from "os";
import { useState } from "react";
import { FormattedDate, FormattedMessage, FormattedNumber } from "react-intl";
import { StyledMovementAtlasBetDataWrapper } from "./styles/StyledMovementAtlasBetData";

type MovementPlacebetDataProps = {
  ticketsData: any;
  currency: string;
};

type Palinsest = {
  [key: string]: Array<any>;
};

const extractSystem = (system: string, ticket: any) => {
  const s: Array<any> = ticket.selections[system];
  const palinsests: Palinsest = {};
  const palinsestsIds: Array<string> = [];

  s.forEach((r: any, i: number) => {
    r.combination.forEach((c: any, ii: number) => {
      const pid: string = c.palimpsestId;
      if (palinsestsIds.indexOf(pid) === -1) {
        palinsests[pid] = [];
        palinsestsIds.push(pid);
      }

      palinsests[pid].push(c);
    });
  });

  return [palinsests, palinsestsIds];
};

const MovementAtlasBetData: React.FC<MovementPlacebetDataProps> = ({
  ticketsData,
  currency,
}) => {
  const [systems, setSystems] = useState(ticketsData.bet.outcomes);

  return (
    <StyledMovementAtlasBetDataWrapper>
      <div>
        <b>{ticketsData.bet.betType}</b>
      </div>
      <ul className="bet-events">
        {systems.map((s: any, i: number) => {
          return (
            <li key={`outcome-${i}`}>
              <b>{s.outcomeName}</b>
              <br />
              <div className="bet-odds">{parseFloat(s.odds).toFixed(2)}</div>
              <span>
                {s.homeScore}:{s.awayScore} {s.marketName}
              </span>
              <br />
              <span className="bet-event-name">{s.localizedEventName}</span>
              <br />
              <span className={`st-${s.outcomeStatus}`}>
                <FormattedMessage id="status" />: {s.outcomeStatus + "".toLowerCase()}
              </span>
            </li>
          );
        })}
      </ul>
      <div>
        <FormattedMessage id="movements.atlas.betdata.odds" /> :{" "}
        <FormattedNumber
          value={ticketsData.bet.odds}
          style="decimal"
          maximumFractionDigits={2}
        />{" "}
        <br />
        <FormattedMessage id="movements.atlas.betdata.bet.time" /> : <FormattedDate value={ticketsData.bet.createTime} />
        <br />
        <FormattedMessage id="movements.atlas.betdata.bet.transaction" /> : {ticketsData.bet.transactionId} <br />
        <FormattedMessage id="movements.atlas.betdata.bet.id" /> : {ticketsData.bet.betId}
      </div>
    </StyledMovementAtlasBetDataWrapper>
  );
};

export default MovementAtlasBetData;
